import React, { useRef } from "react";
import { Button, HStack, Text, Flex, CloseButton } from "@chakra-ui/react";
import { Icon } from "@chakra-ui/icons";
import { FileMapField } from "../insightsProduct";

interface FileInputProps {
  accept?: string;
  value: FileMapField | null;
  onChange: (value: FileMapField | null) => void;
}

const FileInput: React.FC<FileInputProps> = (props) => {
  const { onChange, value } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const fileList = e.target.files;
    const file: File | null = fileList?.length ? fileList[0] : null;
    if (!file) {
      return onChange(null);
    }
    onChange({ name: file.name, file });
  };

  const handleRemoveClick = () => {
    onChange(null);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const FileIcon = () => <i className={`fas fa-file`}></i>;

  const renderFileInput = () => {
    if (value?.name) {
      return (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          borderWidth={1}
          borderRadius={5}
          p={2}
          shadow="sm"
        >
          <HStack ml={2} spacing={3}>
            <Icon as={FileIcon} />
            <Text>{value.name}</Text>
          </HStack>
          <CloseButton size="sm" onClick={handleRemoveClick} />
        </Flex>
      );
    }

    return (
      <HStack>
        <Button onClick={() => inputRef.current?.click()}>Choose File</Button>
        <Text>{inputRef.current?.files?.[0]?.name || "No file selected"}</Text>
      </HStack>
    );
  };

  return (
    <>
      <input
        ref={inputRef}
        accept={props.accept}
        hidden
        onChange={handleOnChange}
        type="file"
      />
      {renderFileInput()}
    </>
  );
};

export default FileInput;
